<h1 #heading>
    <ng-container *ngIf="titleItems?.length; else defaultTitle">
        <ng-container *ngFor="let item of titleItems; let i = index; trackBy: trackByTemplate">
            <ng-container *ngIf="item.link">
                <a [routerLink]="item.link" [class]="item.link ? 'hidden-xs' : ''">
                    <ng-container [ngTemplateOutlet]="item.content"></ng-container>
                </a>
            </ng-container>
            <ng-container *ngIf="item.href">
                <a [href]="item.href">
                    <ng-container [ngTemplateOutlet]="item.content"></ng-container>
                </a>
            </ng-container>
            <ng-container *ngIf="!item.href && !item.link">
                <ng-container [ngTemplateOutlet]="item.content"></ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-template #defaultTitle>
        <span [class]="title.toLowerCase() === 'reports' ? 'hidden-xs' : ''">
            {{ title }}
        </span>
        <ng-content></ng-content>
    </ng-template>
</h1>
